(function($) {
  
  $(document).ready(function() {
        
  });
  
})(jQuery);

function initPagePresentation(){
  var $ = jQuery;
  $('.m-page-presentation .accordion>h4').click(function(){
    var alreadyOpen = $(this).parent().hasClass('is-open');
    $('.accordion').removeClass('is-open');
    if(!alreadyOpen){
        $(this).parent().addClass('is-open');
    }
})
}